import { Box, Button, ClickAwayListener, Tooltip } from "@material-ui/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import LocalCafeIcon from "@material-ui/icons/LocalCafe";
import HelpIcon from "@material-ui/icons/Help";

import { useSummaryStyles } from "./summary.styles";
import { Timer } from "./Timer";
import { closeSummary, makeDateChangeable, updateTabSelected } from "../../../../store/checkoutPage.slide";
import { RootState } from "../../../../app/rootReducer";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const SummaryDate = () => {
  const classes = useSummaryStyles();
  const dispatch = useDispatch();
  const { isMoreThanMd } = useBreakpoint();
  const { date, timer } = useSelector((state: RootState) => state.checkout);
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
    if (!isMoreThanMd)
      setTimeout(() => {
        setOpen(false);
      }, 10000);
  };

  if (!(date && timer)) return null;
  return (
    <Box className={classes.summaryDate}>
      <Box className={classes.summaryDateTitle}>
        <h3>Selected Installation Date</h3>
        <Box display={"flex"} alignItems={"center"} justifyContent="space-between">
          <LocalCafeIcon fontSize="small" htmlColor="#d8d8d8" />
          <Timer date={new Date(timer)} handleTooltipClose={handleTooltipClose} />

          <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
              classes={{ popper: classes.summaryTooltip }}
              PopperProps={{
                disablePortal: true
              }}
              onClose={handleTooltipClose}
              open={open}
              arrow
              disableFocusListener
              disableHoverListener={!isMoreThanMd}
              disableTouchListener
              title="This timer shows how long we'll be able to hold this date during booking. If time runs out, other customers will have a chance to select this date."
            >
              <HelpIcon
                fontSize="small"
                htmlColor="#d8d8d8"
                onClick={handleTooltipOpen}
                onMouseEnter={handleTooltipOpen}
              />
            </Tooltip>
          </ClickAwayListener>
        </Box>
      </Box>
      <Box className={classes.summaryDateTime} display={"flex"} alignItems={"center"} justifyContent="space-between">
        <Box className={classes.time}>{format(new Date(date), "dd MMM yyyy")}</Box>
        <Button
          className={classes.changeTime}
          variant="text"
          onClick={() => {
            if (!isMoreThanMd) dispatch(closeSummary());
            dispatch(updateTabSelected("installation-date"));
            dispatch(makeDateChangeable());
            if (isMoreThanMd) window.scrollTo({ top: 550, behavior: "smooth" });
          }}
        >
          Change
        </Button>
      </Box>
      <Box className={classes.summaryDateContent}>
        Your dedicated customer success manager will contact you shortly after you pay your deposit online to discuss
        next steps
      </Box>
    </Box>
  );
};
